<div class="container-fluid px-0 h-100">
  <div class="row w-100 mx-0 my-0 h-100">
    <pa-member-login class="member-only-payment"></pa-member-login>
    <div class="path"></div>
    <pa-qr-payment class="qr-only-payment"></pa-qr-payment>
    <div class="second-path"></div>
    <div class="w-100 text-center">
      <label class="description" (click)="createTplModal()">Paycell Nedir?</label>
    </div>
  </div>
</div>

